export default "__VITE_ASSET__tTzgrAsC__"